<template>
  <div id="callback-page" class="container-fluid container h-100">
    <stihl-overlay :active="!$route.query.error && !err" :spinner="true">

      <error-block :title="errorTitle" :summary="errorSummary" :message="errorDetails"
                   v-if="$route.query.error || err"/>

    </stihl-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { userManager } from '@/components/oidc';
import ErrorBlock from '@/components/ui/ErrorBlock.vue';
import { initLocale } from '@/lang';

const toString = (x: unknown, def: string | null) => typeof x === 'string' ? x : def;

export default defineComponent({
  name: 'OpenIdConnectCallback',
  components: { ErrorBlock },
  data() {
    return {
      err: '',
    };
  },
  computed: {
    errorTitle(): string {
      if (this.$route.query.error) return 'Oauth error';
      return 'Token endpoint error';
    },
    errorSummary(): string {
      if (this.$route.query.error) return this.$route.query.error as string;
      return '';
    },
    errorDetails(): string {
      if (this.$route.query.error) return this.$route.query.error_description as string;
      return this.err;
    }
  },

  mounted() {

    console.info('processing callback...');

    userManager.signinRedirectCallback()
        .then((user) => {

          window.sessionChecked = true;

          const _goto = toString(user.state, null);
          console.log(`welcome ${user.profile.given_name}, redirecting you back to ${_goto}...`);

          if (_goto) {
            initLocale(this.$getUrlParam(_goto, 'locale'));
          }

          this.$router.push(_goto ? _goto : '/');

        })
        .catch((oauth_error) => {
          //console.error(`Failed to get token: ${oauth_error}`);
          this.err = oauth_error; // usually "No matching state found in storage"
        });
  }
});
</script>

<style scoped>
</style>
